import values from 'lodash/values';
import includes from 'lodash/includes';

import { NotInsuredReason } from '@jerry-serverless/enums/prior_insurance';

export { NotInsuredReason };

/**
 * Check if string value is in enum.
 *
 * @param val
 */
export const isNotInsuredReason = (val?: string | null): val is NotInsuredReason => {
  return includes(values(NotInsuredReason), val);
};

export const NOT_INSURED_REASON_TITLE: Readonly<{ [reason in NotInsuredReason]: string }> = {
  [NotInsuredReason.EXPIRED_LAST_30_DAYS]: 'My insurance expired within the last 30 days',
  [NotInsuredReason.DID_NOT_OWN_VEHICLE]: 'Did not own a vehicle / Newly purchased',
  [NotInsuredReason.DRIVING_WITH_NO_INSURANCE]: 'Owned vehicle and was driving without insurance',
  [NotInsuredReason.DID_NOT_DRIVE_6_MONTHS]: 'Owned vehicle but was not driving in the last 6 months',
  [NotInsuredReason.OVERSEAS_MILITARY]: 'Was overseas in military',
  [NotInsuredReason.OTHER]: 'Other',
};

export const NOT_INSURED_REASONS = [
  NotInsuredReason.EXPIRED_LAST_30_DAYS,
  NotInsuredReason.DID_NOT_OWN_VEHICLE,
  NotInsuredReason.DRIVING_WITH_NO_INSURANCE,
  NotInsuredReason.DID_NOT_DRIVE_6_MONTHS,
  NotInsuredReason.OVERSEAS_MILITARY,
];
